import { RouteView } from "@/layouts";
export default {
  path: "/hospital",
  name: "hospital",
  redirect: "/hospital/index",
  component: RouteView,
  meta: {
    title: "走进医院",
    icon: "shop-o",
    showNavBar: true,
  },
  children: [
    {
      path: "/hospital/index",
      name: "hospitalIndex",
      component: () =>
        import(/* webpackChunkName: "hospital" */ "@/views/hospital/Index.vue"),
      meta: {
        title: "走进医院",
        showNavBar: true,
      },
    },
    {
      path: "/hospital/basic",
      name: "hospitalBasic",
      component: () =>
        import(/* webpackChunkName: "hospital" */ "@/views/hospital/Basic.vue"),
      meta: {
        title: "医院概况",
        showNavBar: false,
      },
    },
    {
      path: "/hospital/department",
      name: "hospitalDepartment",
      component: () =>
        import(/* webpackChunkName: "hospital" */ "@/views/hospital/department/List.vue"),
      meta: {
        title: "科室介绍",
        showNavBar: false,
      },
    },
    {
      path: "/hospital/department/info",
      name: "hospitalDepartmentInfo",
      component: () =>
        import(/* webpackChunkName: "hospital" */ "@/views/hospital/department/Info.vue"),
      meta: {
        title: "科室详情",
        showNavBar: false,
      },
    },

    {
      path: "/hospital/news",
      name: "hospitalNews",
      component: () =>
        import(/* webpackChunkName: "hospital" */ "@/views/hospital/news/List.vue"),
      meta: {
        title: "医院新闻",
        showNavBar: false,
      },
    },
    {
      path: "/hospital/news-info",
      name: "hospitalNewsInfo",
      component: () =>
        import(/* webpackChunkName: "hospital" */ "@/views/hospital/news/Info.vue"),
      meta: {
        title: "",
        showNavBar: false,
      },
    },
    {
      path: "/hospital/comment",
      name: "hospitalComment",
      component: () =>
        import(/* webpackChunkName: "hospital" */ "@/views/hospital/comment/Add.vue"),
      meta: {
        title: "医院满意度调查",
        showNavBar: false,
      },
    },
    {
      path: "/hospital/doctor",
      name: "hospitalDoctor",
      component: () =>
        import(/* webpackChunkName: "hospital" */ "@/views/hospital/doctor/List.vue"),
      meta: {
        title: "医生介绍",
        showNavBar: false,
      },
    },
    {
      path: "/hospital/doctor-info",
      name: "hospitalDoctorInfo",
      component: () =>
        import(/* webpackChunkName: "hospital" */ "@/views/hospital/doctor/Info.vue"),
      meta: {
        title: "医生介绍",
        showNavBar: false,
      },
    },
    {
      path: "/hospital/map",
      name: "hospitalMap",
      component: () =>
        import(/* webpackChunkName: "hospital" */ "@/views/hospital/Map.vue"),
      meta: {
        title: "医院导航",
        showNavBar: false,
      },
    },
    {
      path: "/hospital/priceQuery",
      name: "priceQuery",
      component: () =>
        import(/* webpackChunkName: "hospital" */ "@/views/hospital/priceQuery/index.vue"),
      meta: {
        title: "价格查询",
        showNavBar: false,
      },
    },
    {
      path: "/hospital/priceQueryList",
      name: "priceQueryList",
      component: () =>
        import(/* webpackChunkName: "hospital" */ "@/views/hospital/priceQuery/list.vue"),
      meta: {
        title: "价格查询结果",
        showNavBar: false,
      },
    },
    {
      path: "/nuclein/check",
      name: "nucleinCheck",
      component: () =>
        import(/* webpackChunkName: "hospital" */ "@/views/nuclein/check.vue"),
      meta: {
        title: "核酸检测开单",
        showNavBar: false,
      },
    },
    {
      path: "/nuclein/bill",
      name: "nucleinBill",
      component: () =>
        import(/* webpackChunkName: "hospital" */ "@/views/nuclein/bill.vue"),
      meta: {
        title: "核酸检测开单",
        showNavBar: false,
      },
    },
    {
      path: "/physicalExam/check",
      name: "physicalExamCheck",
      component: () =>
        import(/* webpackChunkName: "hospital" */ "@/views/physicalExam/check.vue"),
      meta: {
        title: "体检开单",
        showNavBar: false,
      },
    },
    {
      path: "/physicalExam/bill",
      name: "physicalExamBill",
      component: () =>
        import(/* webpackChunkName: "hospital" */ "@/views/physicalExam/bill.vue"),
      meta: {
        title: "体检开单",
        showNavBar: false,
      },
    },
    {
      path: "/selfHelp",
      name: "selfHelp",
      component: () =>
        import(/* webpackChunkName: "hospital" */ "@/views/selfHelp/Index.vue"),
      meta: {
        title: "体检自助",
        showNavBar: false,
      },
    },
    {
      path: "/selfBuy/check",
      name: "selfBuyCheck",
      component: () =>
        import(/* webpackChunkName: "hospital" */ "@/views/selfBuy/check.vue"),
      meta: {
        title: "自助开单",
        showNavBar: false,
      },
    },
    {
      path: "/selfBuy/bill",
      name: "selfBuyBill",
      component: () =>
        import(/* webpackChunkName: "hospital" */ "@/views/selfBuy/bill.vue"),
      meta: {
        title: "核酸检测开单",
        showNavBar: false,
      },
    },
  ],
};
